module.exports = __webpack_public_path__ + "img/image_why01.60738a4e.png";